<template>
    <!-- 现场图片 -->
    <div>
        <!-- 头部-->
        <div class="child-head">
            <!-- 标题 -->
            <div class="child-head-left float-l">
                <img src="../../assets/area_title.png" class="head-img">
                <span>现场图片</span>
            </div>
        </div>
        <!-- 内容 -->
        <div class="content content-chunk-box">
            <!-- 边角 -->
            <contentCorner>
                <!-- 内容 -->
                <div class="city-box">
                    <dv-scroll-board class="dv-scr-board" :config="config" ref="scrollBoard" />
                </div>
            </contentCorner>

        </div>
    </div>
</template>
<script>
import contentCorner from '../../components/common/contentCorner.vue';
import { newestAttachment } from '../../api/holdMy.js';
export default {

    data() {
        return {
            imgList: [],
            refreshImgIng: null,   // 刷新定时器
            config: {
                data: [],
                header: [],
                rowNum: 1, //表格行
                oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
                evenRowBGC: 'rgba(26, 201, 255, 0)', //偶数行
                align: ['center'],
                waitTime: 1000 * 25,
            }
        }
    },
    components: { contentCorner },
    created() {

    },
    mounted() {
        this.refreshScale();
    },

    beforeDestroy() {
        clearInterval(this.refreshImgIng);
    },
    methods: {
        // 刷新数据
        refreshScale() {
            this.getNewestAttachment();
            this.refreshImgIng = setInterval(() => {
                this.getNewestAttachment();
            }, 1000 * 60)
        },

        // 获取平台车辆
        getNewestAttachment() {
            newestAttachment({}).then(res => {
                if (res.result == 0) {
                    this.imgList = res.userdata;
                    var data1 = [];
                    this.imgList.forEach(element => {
                        if (element.city != "") {
                            data1.push(["<div  style='width: 100%; height: 100%;text-align: center;'><img style='width: 100%; height: 100%;object-fit: contain;vertical-align: middle;' height='100%' src=" + element.attachmentName + " /></div>"])
                        }
                    });
                    this.$refs['scrollBoard'].updateRows(data1)
                }
            }).catch(error => {
                console.log(error);
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 358px;

}

.city-box {
    overflow: hidden;
    height: 355px;
    padding: 20px;

}

::v-deep .dv-scroll-board .rows .ceil {
    width: 100%;
}
</style>